// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__16vGs","bigColWidth":"Table_bigColWidth__2DTbR","biggerColWidth":"Table_biggerColWidth__snFGv","row":"Table_row__Ryq8s","col":"Table_col__1v4KM"};